{
  "three-acts": {
    "name": "Trois actes",
    "summary": "Mise en place, confrontation et résolution : la forme commune à la plupart des romans et des films.",
    "bestFor": "Tous les genres, et un premier jet que vous voulez garder simple.",
    "metaTitle": "Modèle narratif en trois actes — Musael",
    "metaDescription": "Mise en place, confrontation et résolution, comme dans la plupart des romans et films. Pour tous les genres et un premier jet simple.",
    "acts": [
      {
        "title": "Acte I : Mise en place",
        "synopsis": "Qui est le protagoniste, ce qu'il veut et l'événement qui met fin à sa vie ordinaire.",
        "chapters": [
          {
            "title": "Le monde ordinaire",
            "synopsis": "Le protagoniste chez lui, avec le désir et la faille que le récit mettra à l'épreuve.",
            "scenes": [
              {
                "title": "Image d'ouverture",
                "synopsis": "Un aperçu du protagoniste avant que tout change."
              },
              {
                "title": "L'accroche",
                "synopsis": "Un détail étrange qui annonce des ennuis."
              }
            ]
          },
          {
            "title": "L'élément déclencheur",
            "synopsis": "L'événement que le protagoniste ne peut ignorer.",
            "scenes": [
              {
                "title": "Élément déclencheur",
                "synopsis": "Le problème survient et ne disparaît pas."
              },
              {
                "title": "Hésitation",
                "synopsis": "Le protagoniste hésite, et l'on voit ce qu'il risque de perdre."
              }
            ]
          },
          {
            "title": "Le franchissement du seuil",
            "synopsis": "Le protagoniste s'engage ; revenir en arrière n'est plus facile.",
            "scenes": [
              {
                "title": "La décision",
                "synopsis": "Le protagoniste choisit d'agir et quitte ce qui lui est familier."
              }
            ]
          }
        ]
      },
      {
        "title": "Acte II : Confrontation",
        "synopsis": "Le protagoniste tente, échoue et apprend, tandis que les enjeux grandissent.",
        "chapters": [
          {
            "title": "Les enjeux montent",
            "synopsis": "Nouvelles règles, alliés et ennemis ; les premières victoires ont un prix.",
            "scenes": [
              {
                "title": "Première épreuve",
                "synopsis": "Le protagoniste découvre le nouveau monde et se trompe en partie sur lui."
              },
              {
                "title": "Alliés et ennemis",
                "synopsis": "Qui aide, qui fait obstacle, et pourquoi."
              }
            ]
          },
          {
            "title": "Le point médian",
            "synopsis": "Un renversement qui change le sens de l'histoire.",
            "scenes": [
              {
                "title": "Point médian",
                "synopsis": "Une fausse victoire ou une fausse défaite ; le protagoniste cesse de réagir et prend l'initiative."
              }
            ]
          },
          {
            "title": "Tout s'effondre",
            "synopsis": "L'opposition se resserre et la faille du protagoniste lui coûte cher.",
            "scenes": [
              {
                "title": "L'étau se resserre",
                "synopsis": "Chaque plan rencontre une résistance ; les relations se fissurent."
              },
              {
                "title": "Tout est perdu",
                "synopsis": "Le point le plus bas : l'objectif paraît définitivement hors d'atteinte."
              }
            ]
          }
        ]
      },
      {
        "title": "Acte III : Résolution",
        "synopsis": "Le protagoniste change, affronte l'épreuve finale et une nouvelle vie commence.",
        "chapters": [
          {
            "title": "Le point culminant",
            "synopsis": "La confrontation finale, remportée grâce à la leçon du deuxième acte.",
            "scenes": [
              {
                "title": "Le plan final",
                "synopsis": "Le protagoniste rassemble ce qu'il a appris et fait une dernière tentative."
              },
              {
                "title": "Point culminant",
                "synopsis": "La confrontation décisive."
              }
            ]
          },
          {
            "title": "Le nouvel équilibre",
            "synopsis": "Ce qui a changé, pour le protagoniste et pour le monde.",
            "scenes": [
              {
                "title": "Image de clôture",
                "synopsis": "Un miroir de l'image d'ouverture, qui montre le chemin parcouru par le protagoniste."
              }
            ]
          }
        ]
      }
    ]
  },
  "heros-journey": {
    "name": "Le voyage du héros",
    "summary": "Douze étapes de l'appel à l'aventure au retour chez soi, réparties entre départ, initiation et retour.",
    "bestFor": "Fantasy, aventures et quêtes.",
    "metaTitle": "Modèle du voyage du héros — Musael",
    "metaDescription": "Douze étapes de l'appel à l'aventure au retour chez soi : départ, initiation et retour. Pour la fantasy, les aventures et les quêtes.",
    "acts": [
      {
        "title": "Départ",
        "synopsis": "Le protagoniste quitte le monde connu.",
        "chapters": [
          {
            "title": "Le monde ordinaire",
            "synopsis": "Le protagoniste avant l'aventure : son foyer, ses habitudes et ce qui lui manque.",
            "scenes": [
              {
                "title": "Le monde ordinaire",
                "synopsis": "Le protagoniste avant l'aventure : son foyer, ses habitudes et ce qui lui manque."
              }
            ]
          },
          {
            "title": "L'appel à l'aventure",
            "synopsis": "Un défi ou un message trouble le monde ordinaire.",
            "scenes": [
              {
                "title": "L'appel à l'aventure",
                "synopsis": "Un défi ou un message trouble le monde ordinaire."
              }
            ]
          },
          {
            "title": "Le refus de l'appel",
            "synopsis": "La peur ou le devoir retient le protagoniste.",
            "scenes": [
              {
                "title": "Le refus de l'appel",
                "synopsis": "La peur ou le devoir retient le protagoniste."
              }
            ]
          },
          {
            "title": "La rencontre avec le mentor",
            "synopsis": "Quelqu'un offre des conseils, un entraînement ou un don.",
            "scenes": [
              {
                "title": "La rencontre avec le mentor",
                "synopsis": "Quelqu'un offre des conseils, un entraînement ou un don."
              }
            ]
          },
          {
            "title": "Le franchissement du premier seuil",
            "synopsis": "Le protagoniste entre dans le monde extraordinaire.",
            "scenes": [
              {
                "title": "Le franchissement du premier seuil",
                "synopsis": "Le protagoniste entre dans le monde extraordinaire."
              }
            ]
          }
        ]
      },
      {
        "title": "Initiation",
        "synopsis": "Les épreuves du monde extraordinaire, puis la grande épreuve.",
        "chapters": [
          {
            "title": "Épreuves, alliés et ennemis",
            "synopsis": "Le protagoniste apprend les règles du nouveau monde.",
            "scenes": [
              {
                "title": "Épreuves, alliés et ennemis",
                "synopsis": "Le protagoniste apprend les règles du nouveau monde."
              }
            ]
          },
          {
            "title": "L'approche de la caverne profonde",
            "synopsis": "Les préparatifs face au danger central.",
            "scenes": [
              {
                "title": "L'approche de la caverne profonde",
                "synopsis": "Les préparatifs face au danger central."
              }
            ]
          },
          {
            "title": "L'épreuve suprême",
            "synopsis": "Une crise de vie ou de mort ; quelque chose meurt en lui.",
            "scenes": [
              {
                "title": "L'épreuve suprême",
                "synopsis": "Une crise de vie ou de mort ; quelque chose meurt en lui."
              }
            ]
          },
          {
            "title": "La récompense",
            "synopsis": "Le protagoniste obtient le trésor, la connaissance ou la réconciliation.",
            "scenes": [
              {
                "title": "La récompense",
                "synopsis": "Le protagoniste obtient le trésor, la connaissance ou la réconciliation."
              }
            ]
          }
        ]
      },
      {
        "title": "Retour",
        "synopsis": "Le chemin du retour, une dernière épreuve et ce que le protagoniste rapporte.",
        "chapters": [
          {
            "title": "Le chemin du retour",
            "synopsis": "Le protagoniste rentre chez lui, souvent poursuivi.",
            "scenes": [
              {
                "title": "Le chemin du retour",
                "synopsis": "Le protagoniste rentre chez lui, souvent poursuivi."
              }
            ]
          },
          {
            "title": "Résurrection",
            "synopsis": "Une dernière épreuve où tout ce qui a été appris est mis à profit.",
            "scenes": [
              {
                "title": "Résurrection",
                "synopsis": "Une dernière épreuve où tout ce qui a été appris est mis à profit."
              }
            ]
          },
          {
            "title": "Le retour avec l'élixir",
            "synopsis": "Le protagoniste rentre transformé, avec quelque chose à partager.",
            "scenes": [
              {
                "title": "Le retour avec l'élixir",
                "synopsis": "Le protagoniste rentre transformé, avec quelque chose à partager."
              }
            ]
          }
        ]
      }
    ]
  },
  "fifteen-beats": {
    "name": "Plan en quinze temps",
    "summary": "Le plan des scénaristes : quinze tournants répartis sur trois actes.",
    "bestFor": "Des intrigues commerciales resserrées, avec des tournants nets.",
    "metaTitle": "Modèle narratif en quinze temps — Musael",
    "metaDescription": "Le plan des scénaristes : quinze tournants en trois actes. Pour des intrigues commerciales resserrées, aux tournants nets.",
    "acts": [
      {
        "title": "Acte I",
        "synopsis": "Le monde d'avant et le choix de le quitter.",
        "chapters": [
          {
            "title": "Image d'ouverture",
            "synopsis": "Le protagoniste et le monde avant l'histoire.",
            "scenes": [
              {
                "title": "Image d'ouverture",
                "synopsis": "Le protagoniste et le monde avant l'histoire."
              }
            ]
          },
          {
            "title": "Le thème est énoncé",
            "synopsis": "Quelqu'un dit de quoi l'histoire parle vraiment ; le protagoniste ne le comprend pas encore.",
            "scenes": [
              {
                "title": "Le thème est énoncé",
                "synopsis": "Quelqu'un dit de quoi l'histoire parle vraiment ; le protagoniste ne le comprend pas encore."
              }
            ]
          },
          {
            "title": "Mise en place",
            "synopsis": "La vie du protagoniste, son entourage et ce qui doit être réparé.",
            "scenes": [
              {
                "title": "Mise en place",
                "synopsis": "La vie du protagoniste, son entourage et ce qui doit être réparé."
              }
            ]
          },
          {
            "title": "Catalyseur",
            "synopsis": "L'événement qui met l'histoire en mouvement.",
            "scenes": [
              {
                "title": "Catalyseur",
                "synopsis": "L'événement qui met l'histoire en mouvement."
              }
            ]
          },
          {
            "title": "Hésitation",
            "synopsis": "Le protagoniste hésite sur la marche à suivre.",
            "scenes": [
              {
                "title": "Hésitation",
                "synopsis": "Le protagoniste hésite sur la marche à suivre."
              }
            ]
          },
          {
            "title": "Entrée dans le deuxième acte",
            "synopsis": "Le protagoniste choisit une nouvelle voie.",
            "scenes": [
              {
                "title": "Entrée dans le deuxième acte",
                "synopsis": "Le protagoniste choisit une nouvelle voie."
              }
            ]
          }
        ]
      },
      {
        "title": "Acte II",
        "synopsis": "La promesse de la prémisse, puis la chute.",
        "chapters": [
          {
            "title": "Intrigue secondaire",
            "synopsis": "Une histoire secondaire, souvent une relation, qui porte le thème.",
            "scenes": [
              {
                "title": "Intrigue secondaire",
                "synopsis": "Une histoire secondaire, souvent une relation, qui porte le thème."
              }
            ]
          },
          {
            "title": "Jeux et découvertes",
            "synopsis": "La prémisse se concrétise : ce que les lecteurs sont venus chercher.",
            "scenes": [
              {
                "title": "Jeux et découvertes",
                "synopsis": "La prémisse se concrétise : ce que les lecteurs sont venus chercher."
              }
            ]
          },
          {
            "title": "Point médian",
            "synopsis": "Une fausse victoire ou défaite augmente les enjeux.",
            "scenes": [
              {
                "title": "Point médian",
                "synopsis": "Une fausse victoire ou défaite augmente les enjeux."
              }
            ]
          },
          {
            "title": "Les adversaires se rapprochent",
            "synopsis": "Le doute à l'intérieur, la pression à l'extérieur.",
            "scenes": [
              {
                "title": "Les adversaires se rapprochent",
                "synopsis": "Le doute à l'intérieur, la pression à l'extérieur."
              }
            ]
          },
          {
            "title": "Tout est perdu",
            "synopsis": "L'inverse du point médian : le moment le plus bas.",
            "scenes": [
              {
                "title": "Tout est perdu",
                "synopsis": "L'inverse du point médian : le moment le plus bas."
              }
            ]
          },
          {
            "title": "La nuit obscure de l'âme",
            "synopsis": "Le protagoniste fait le deuil de ce qu'il a perdu et en tire la leçon.",
            "scenes": [
              {
                "title": "La nuit obscure de l'âme",
                "synopsis": "Le protagoniste fait le deuil de ce qu'il a perdu et en tire la leçon."
              }
            ]
          }
        ]
      },
      {
        "title": "Acte III",
        "synopsis": "La leçon mise en pratique.",
        "chapters": [
          {
            "title": "Entrée dans le troisième acte",
            "synopsis": "Une idée nouvelle, issue de l'intrigue secondaire, ouvre une voie.",
            "scenes": [
              {
                "title": "Entrée dans le troisième acte",
                "synopsis": "Une idée nouvelle, issue de l'intrigue secondaire, ouvre une voie."
              }
            ]
          },
          {
            "title": "Final",
            "synopsis": "Le protagoniste répare ce qui était brisé et change pour de bon.",
            "scenes": [
              {
                "title": "Final",
                "synopsis": "Le protagoniste répare ce qui était brisé et change pour de bon."
              }
            ]
          },
          {
            "title": "Image finale",
            "synopsis": "Le monde d'après, en miroir de l'image d'ouverture.",
            "scenes": [
              {
                "title": "Image finale",
                "synopsis": "Le monde d'après, en miroir de l'image d'ouverture."
              }
            ]
          }
        ]
      }
    ]
  },
  "seven-point": {
    "name": "Structure en sept points",
    "summary": "Construisez à rebours depuis la fin : accroche, tournants, pressions, point médian et résolution.",
    "bestFor": "Les auteurs qui connaissent d'abord la fin.",
    "metaTitle": "Modèle narratif en sept points — Musael",
    "metaDescription": "Partez de la fin : accroche, tournants, pressions, point médian et résolution. Pour les auteurs qui connaissent d'abord le dénouement.",
    "acts": [
      {
        "title": "",
        "synopsis": "",
        "chapters": [
          {
            "title": "Accroche",
            "synopsis": "La situation initiale, à l'opposé de la résolution.",
            "scenes": [
              {
                "title": "Accroche",
                "synopsis": "La situation initiale, à l'opposé de la résolution."
              }
            ]
          },
          {
            "title": "Tournant narratif 1",
            "synopsis": "Le conflit commence et pousse le protagoniste à agir.",
            "scenes": [
              {
                "title": "Tournant narratif 1",
                "synopsis": "Le conflit commence et pousse le protagoniste à agir."
              }
            ]
          },
          {
            "title": "Pression 1",
            "synopsis": "L'antagoniste exerce une pression ; le protagoniste doit agir.",
            "scenes": [
              {
                "title": "Pression 1",
                "synopsis": "L'antagoniste exerce une pression ; le protagoniste doit agir."
              }
            ]
          },
          {
            "title": "Point médian",
            "synopsis": "Le protagoniste passe de la réaction à l'action.",
            "scenes": [
              {
                "title": "Point médian",
                "synopsis": "Le protagoniste passe de la réaction à l'action."
              }
            ]
          },
          {
            "title": "Pression 2",
            "synopsis": "Tout tourne mal ; le plan échoue.",
            "scenes": [
              {
                "title": "Pression 2",
                "synopsis": "Tout tourne mal ; le plan échoue."
              }
            ]
          },
          {
            "title": "Tournant narratif 2",
            "synopsis": "Le protagoniste obtient la dernière pièce nécessaire pour gagner.",
            "scenes": [
              {
                "title": "Tournant narratif 2",
                "synopsis": "Le protagoniste obtient la dernière pièce nécessaire pour gagner."
              }
            ]
          },
          {
            "title": "Résolution",
            "synopsis": "La situation finale, la réponse à l'accroche.",
            "scenes": [
              {
                "title": "Résolution",
                "synopsis": "La situation finale, la réponse à l'accroche."
              }
            ]
          }
        ]
      }
    ]
  },
  "kishotenketsu": {
    "name": "Kishōtenketsu",
    "summary": "Quatre mouvements construits autour d'un retournement plutôt que d'un conflit.",
    "bestFor": "La fiction littéraire, les nouvelles et les récits calmes centrés sur les personnages.",
    "metaTitle": "Modèle narratif Kishōtenketsu — Musael",
    "metaDescription": "Quatre mouvements autour d'un retournement plutôt que d'un conflit. Pour la fiction littéraire, les nouvelles et les récits calmes centrés sur les personnages.",
    "acts": [
      {
        "title": "",
        "synopsis": "",
        "chapters": [
          {
            "title": "Ki : introduction",
            "synopsis": "Les personnages et leur monde, posément.",
            "scenes": [
              {
                "title": "Introduction",
                "synopsis": "Qui, où et à quoi ressemble le quotidien."
              }
            ]
          },
          {
            "title": "Shō : développement",
            "synopsis": "La situation s'approfondit, sans tournant pour l'instant.",
            "scenes": [
              {
                "title": "Développement",
                "synopsis": "On connaît mieux les personnages ; de petites choses changent."
              }
            ]
          },
          {
            "title": "Ten : retournement",
            "synopsis": "Un élément inattendu change notre regard sur l'ensemble.",
            "scenes": [
              {
                "title": "Le retournement",
                "synopsis": "Un élément nouveau arrive, apparemment sans rapport."
              }
            ]
          },
          {
            "title": "Ketsu : réconciliation",
            "synopsis": "Les parties se rejoignent et font émerger une nouvelle compréhension.",
            "scenes": [
              {
                "title": "Réconciliation",
                "synopsis": "Le retournement rejoint l'histoire ; le sens évolue."
              }
            ]
          }
        ]
      }
    ]
  },
  "mystery": {
    "name": "Policier",
    "summary": "Un crime, une enquête entre indices et fausses pistes, puis une révélation loyale envers le lecteur.",
    "bestFor": "Romans criminels, enquêtes et cosy mysteries.",
    "metaTitle": "Modèle de roman policier — Musael",
    "metaDescription": "Un crime, des indices, des fausses pistes et une révélation loyale envers le lecteur. Pour les romans criminels, enquêtes et cosy mysteries.",
    "acts": [
      {
        "title": "Le crime",
        "synopsis": "Quelque chose ne va pas, et quelqu'un doit découvrir pourquoi.",
        "chapters": [
          {
            "title": "La découverte",
            "synopsis": "Le crime ou la disparition.",
            "scenes": [
              {
                "title": "Le corps",
                "synopsis": "Le crime est découvert ; premières impressions et premières questions."
              },
              {
                "title": "L'enquêteur",
                "synopsis": "Qui enquête et pourquoi l'affaire compte à ses yeux."
              }
            ]
          }
        ]
      },
      {
        "title": "L'enquête",
        "synopsis": "Indices, suspects et fausses pistes.",
        "chapters": [
          {
            "title": "Suspects",
            "synopsis": "Tous ceux qui ont un mobile et un alibi.",
            "scenes": [
              {
                "title": "Entretiens",
                "synopsis": "Chaque suspect a une raison de mentir."
              },
              {
                "title": "Le premier indice",
                "synopsis": "Un fait qui comptera plus tard ; soyez loyal envers le lecteur."
              }
            ]
          },
          {
            "title": "Fausses pistes",
            "synopsis": "L'enquête part dans la mauvaise direction.",
            "scenes": [
              {
                "title": "Une fausse piste",
                "synopsis": "Les preuves désignent la mauvaise personne."
              },
              {
                "title": "L'escalade",
                "synopsis": "Un second crime ou une menace augmente les enjeux."
              }
            ]
          },
          {
            "title": "La vérité cachée",
            "synopsis": "L'enquêteur voit ce qui a toujours été là.",
            "scenes": [
              {
                "title": "La pièce manquante",
                "synopsis": "Un petit détail relie les indices précédents."
              }
            ]
          }
        ]
      },
      {
        "title": "La révélation",
        "synopsis": "La solution et son prix.",
        "chapters": [
          {
            "title": "La solution",
            "synopsis": "Chaque indice est expliqué.",
            "scenes": [
              {
                "title": "La révélation",
                "synopsis": "Le coupable est nommé et le raisonnement exposé."
              },
              {
                "title": "Les conséquences",
                "synopsis": "La justice, ou son absence, et ce que l'enquêteur garde de l'affaire."
              }
            ]
          }
        ]
      }
    ]
  },
  "romance": {
    "name": "Romance",
    "summary": "Deux personnes, ce qui les sépare et ce qu'il leur faut pour se choisir.",
    "bestFor": "Romances et histoires d'amour dans tous les univers.",
    "metaTitle": "Modèle narratif de romance — Musael",
    "metaDescription": "Deux personnes, ce qui les sépare et ce qu'il leur faut pour se choisir. Pour les romances et histoires d'amour dans tous les univers.",
    "acts": [
      {
        "title": "Tomber amoureux",
        "synopsis": "Ils se rencontrent, résistent et commencent à s'aimer.",
        "chapters": [
          {
            "title": "La rencontre",
            "synopsis": "La première rencontre, avec l'étincelle et l'obstacle.",
            "scenes": [
              {
                "title": "Rencontre",
                "synopsis": "Les deux protagonistes se rencontrent ; quelque chose chez l'autre les touche profondément."
              },
              {
                "title": "Résistance",
                "synopsis": "Pourquoi cela ne peut pas fonctionner : objectifs, blessures ou circonstances."
              }
            ]
          },
          {
            "title": "Le rapprochement",
            "synopsis": "Contraints de se côtoyer, ils se voient tels qu'ils sont.",
            "scenes": [
              {
                "title": "Ensemble par hasard",
                "synopsis": "Une situation les maintient proches."
              },
              {
                "title": "Le premier moment authentique",
                "synopsis": "Un aperçu de qui est vraiment l'autre."
              }
            ]
          }
        ]
      },
      {
        "title": "Douter",
        "synopsis": "L'engagement, puis la peur qui le brise.",
        "chapters": [
          {
            "title": "Le point médian",
            "synopsis": "Ils cèdent à ce qu'ils ressentent.",
            "scenes": [
              {
                "title": "L'engagement",
                "synopsis": "Un baiser, un aveu ou une promesse."
              }
            ]
          },
          {
            "title": "La rupture",
            "synopsis": "L'ancienne blessure ou l'obstacle extérieur l'emporte, pour l'instant.",
            "scenes": [
              {
                "title": "Doute",
                "synopsis": "Les anciennes peurs reviennent."
              },
              {
                "title": "La séparation",
                "synopsis": "Ils se quittent, chacun convaincu d'avoir raison."
              }
            ]
          }
        ]
      },
      {
        "title": "Choisir",
        "synopsis": "L'évolution, un grand geste et un avenir commun.",
        "chapters": [
          {
            "title": "Ensemble",
            "synopsis": "Chacun change assez pour mériter l'autre.",
            "scenes": [
              {
                "title": "Le grand geste",
                "synopsis": "L'un des deux risque tout pour montrer qu'il a changé."
              },
              {
                "title": "Heureux pour toujours",
                "synopsis": "Ou heureux pour l'instant : l'avenir qu'ils choisissent."
              }
            ]
          }
        ]
      }
    ]
  }
}
